<template>
   <v-card-text>
      <div class="display-1 text--primary">{{title}}</div>
      <p class="pa-0 ma-0">{{text}}</p>
    </v-card-text>
</template>

<script>
import mixin from '../../mixins/base-mixin'
import inputMixin from '../../mixins/input-mixin'

export default {
  name: 'dr-card-label-component',
  mixins: [mixin, inputMixin],
  computed: {
    title() {
      return this.evaluateExpression(this.model.Title)
    },
    text() {
      return this.evaluateExpression(this.model.Text)
    }
  }
}
</script>

<style>

</style>